import { createRoot } from 'react-dom/client';
import { InitMuiLicense } from '@climatepartner/components';
import App from './App';
import { refresh } from './refresh';
import { FeatureToggleInit } from './plugins/featureToggles';

window.addEventListener('load', async () => {
    await refresh(() => {
        InitMuiLicense(import.meta.env.VITE_MUI_LICENSE_KEY);

        const configcatApiKey = window.$cp.config_cat_sdk_key;

        if (!configcatApiKey) {
            console.error('ConfigCat missing apiKey');
        } else {
            FeatureToggleInit(configcatApiKey);
        }

        const container = document.getElementById('root');
        if (!container) {
            throw new Error('Root container could not be found.');
        }

        const root = createRoot(container);

        root.render(<App />);
    });
});
